import vouchers from "../services/vouchers";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        vouchers: [],
        voucherDetails: [],
        ratings: [],
        comments: [],
        instructorDetails: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        errors: null,
        editing: false,
        searchableFields: [
            {
                value: "all",
                text: "All"
            },
            {
                value: "active",
                text: "Active"
            },
            {
                value: "inactive",
                text: "Inactive"
            }
        ]
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        vouchers(state, vouchers) {
            state.vouchers = vouchers;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        editing(state, value) {
            state.editing = value;
        },
        setDetails(state, details) {
            state.voucherDetails = details;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        }
    },
    actions: {
        async getVouchers({ commit }, param) {
            commit("loading");
            try {
                let response = await vouchers.getVouchers(param);

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }

                for (let index = 0; index < response.list.length; index++) {
                    if (response.list[index].description.length > 100) {
                        response.list[index].description = `${response.list[index].description.substring(0, 100)}...`;
                    }
                }

                await commit("vouchers", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async saveVoucher({ commit }, param) {
            commit("loading");
            try {
                let response = await vouchers.saveVoucher(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new voucher.");
                commit("errors", errors);
                console.log(errors);
                commit("loading", false);
            }
        },
        async updateVoucher({ commit }, data) {
            commit("loading");
            try {
                let response = await vouchers.updateVoucher(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot update voucher.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewVoucher({ commit }, uuid) {
            commit("loading");
            try {
                let response = await vouchers.viewVoucher(uuid);
                response.model.validity_days = JSON.parse(response.model.validity_days);
                commit("setDetails", response.model);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                console.log(errors);
                commit("loading", false);
            }
        },
        async deleteVoucher({ commit }, param) {
            commit("loading");
            try {
                let response = await vouchers.deleteVoucher(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot update voucher.");
                }
                commit("errors", errors);
                console.log(errors);
                commit("loading", false);
            }
        },
        async exportVouchers({ commit }, param) {
            commit("loading");
            try {
                let response = await vouchers.exportVouchers(param);
                window.open(response.url);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
    }
};
